import { HStack, Text } from '@rbilabs/universal-components';

export const PriceAndCaloriesWrapper = HStack.withConfig({
  width: 'full',
  flexDirection: 'row',
  marginTop: 0,
  marginBottom: 3,
  space: '$2',
  alignItems: 'center',
  _web: { justifyContent: 'center' },
});

export const PriceCaloriesText = Text.withConfig({
  fontSize: {
    base: 'lg',
    md: '2xl',
  },
});
